import styled, { css } from 'styled-components'
import { Image } from '@sainsburys-tech/bolt'

const Main = styled.div`
  background: ${(props) => props.theme.tokens.color.palette.brand2};
  padding: 20px 0;
  display: flex;
  color: ${(props) => props.theme.tokens.color.monochrome.white};
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin: 20px -15px;
  width: calc(100% + 30px);

  @media (min-width: ${(props) => props.theme.screen_md_min}) {
    flex-direction: row;
    text-align: left;
    margin: 20px auto;
    width: 100%;
  }
`
const Prompt = styled.p`
  && {
    margin-bottom: 0;
  }
`

const Links = styled.div`
  display: flex;
  height: 40px;
  margin: 15px 0 0;

  @media (min-width: ${(props) => props.theme.screen_md_min}) {
    margin: 0;
  }
`

const Text = styled.div`
  margin: 0;

  @media (min-width: ${(props) => props.theme.screen_md_min}) {
    margin: 0 30px 0 0;
  }
`

const Logo = styled(Image)`
  margin: 4px 15px 0 0;
  height: 38px;
  width: 28px;
  display: none;

  @media (min-width: ${(props) => props.theme.screen_md_min}) {
    display: inline-block;
  }
`

const StoreLink = styled(Image)`
  ${(props) =>
    props.store === 'apple' &&
    css`
      margin: 0 15px 0 0;
    `}
`

export { Main, Links, Text, Logo, StoreLink, Prompt }
